"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({params}) {
        this.state = {
            siteId: params && params.id,
            submitting: false,
            showPosterPlus: false,
            suggestions: []
        };
        this.fhandler = new FormHandler({
            key: `${ this.state.siteId ? 'edit' : 'create' }-website`,
            autosave: true
        });
        this.fhandler.bind(this);
        if (this.state.siteId)
            this.getSite();
    },
    onMount: function () {
        const title = this.state.siteId ? 'Edit Website' : 'Create Website', path = this.state.siteId ? `/edit-website/${ this.state.siteId }` : '/create-website';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path
        })).on('reset', () => GState.activity.remove(title));
    },
    getSite: async function () {
        try {
            const {error, message, site} = await Request(`/site/${ this.state.siteId }`);
            if (error)
                throw new Error(message);
            this.fhandler.fill({
                title: site.title,
                description: site.description
            });
        } catch (error) {
            this.fhandler.alert(error);
        }
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.title)
            return this.state.formError.title = true;
        if (!Form.description)
            return this.state.formError.description = true;
        this.state.submitting = true;
        try {
            const url = this.state.siteId ? `/site/update/${ this.state.siteId }` : '/site/create', method = this.state.siteId ? 'PUT' : 'POST', {error, message} = await Request(url, method, Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
            setTimeout(() => navigate('/website'), 5000);
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Website/Create.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "form-group"
      },
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c008f4"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "col-4 pr-50"
      },
    marko_attrs3 = {
        "class": "col pl-50"
      },
    marko_attrs4 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@" + ((state.siteId ? "edit" : "create") + "-website"), component);

              out.be("div", null, "2", component);

              out.be("div", marko_attrs0, "3", component);

              out.e("input", {
                  type: "text",
                  value: state.form.title,
                  name: "title",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.title != undefined ? state.formError.title ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Title")
                }, "4", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2" + (!state.formError.title ? " d-none" : ""))
                }, "5", component, null, 1);

              Locale_tag({
                  text: "Title is required"
                }, out, __component, "6");

              out.ee();

              out.ee();

              out.e("div", marko_attrs1, "7", component, 1)
                .e("textarea", {
                    type: "text",
                    value: state.form.description,
                    required: true,
                    name: "description",
                    "class": marko_classValue("form-control form-control-xl pl-4 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                    placeholder: Locale("Description"),
                    style: marko_styleValue({
                        height: "100px",
                        resize: "none"
                      })
                  }, "8", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

              out.n(marko_node0, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "10");

              Row_tag({
                  renderBody: function(out) {
                    out.e("div", marko_attrs2, "12", component, 1)
                      .e("button", marko_attrs4, "13", component, 1, 0, {
                          onclick: __component.d("click", "onReset", false)
                        })
                        .t("Reset");

                    out.be("div", marko_attrs3, "14", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.submitting
                      }, "15", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "16");

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "17");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "11");

              out.ee();

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
